/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum ShipmentDocumentSource {
  EmailAttachment = "email_attachment",
  ManuallyUploaded = "manually_uploaded",
  Api = "api",
  WebsiteScraped = "website_scraped",
  Generated = "generated",
  Edi = "edi",
}

export function instanceOfShipmentDocumentSource(value: any): boolean {
  for (const key in ShipmentDocumentSource) {
    if (Object.prototype.hasOwnProperty.call(ShipmentDocumentSource, key)) {
      if (
        ShipmentDocumentSource[key as keyof typeof ShipmentDocumentSource] ===
        value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function ShipmentDocumentSourceFromJSON(
  json: any,
): ShipmentDocumentSource {
  return ShipmentDocumentSourceFromJSONTyped(json, false);
}

export function ShipmentDocumentSourceFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ShipmentDocumentSource {
  return json as ShipmentDocumentSource;
}

export function ShipmentDocumentSourceToJSON(
  value?: ShipmentDocumentSource | null,
): any {
  return value as any;
}

export function ShipmentDocumentSourceToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): ShipmentDocumentSource {
  return value as ShipmentDocumentSource;
}
